import { FC, ReactNode } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { useCurrentProjectId } from '@adsk/alloy-provider';
import { LocationProvider } from '@adsk/acc-locations-components';
import FeatureFlagsProvider from './FeatureFlagsProvider';
import LocalizationProvider from './LocalizationProvider';
import { OxygenProvider } from './OxygenProvider';
import { RFIsUsersProvider } from './RFIsUsersProvider';
import { DEFAULT_FEATURE_FLAGS_VALUES } from '../constants';

type ProvidersProps = {
  localizationLoader?: ReactNode;
};

const Providers: FC<ProvidersProps> = ({ children, localizationLoader = null }) => {
  const queryClient = new QueryClient();
  const projectId = useCurrentProjectId();

  return (
    <QueryClientProvider client={queryClient}>
      <RFIsUsersProvider>
        <OxygenProvider>
          <LocalizationProvider loader={localizationLoader}>
            <LocationProvider projectId={projectId}>{children}</LocationProvider>
          </LocalizationProvider>
        </OxygenProvider>
      </RFIsUsersProvider>
    </QueryClientProvider>
  );
};

type RfisProviderProps = {
  localizationLoader?: ReactNode;
  featureFlagLoader?: ReactNode;
};

const RfisProvider: FC<RfisProviderProps> = ({
  children,
  featureFlagLoader = null,
  localizationLoader = null,
}) => (
  <FeatureFlagsProvider
    defaultFeatureFlagsValues={DEFAULT_FEATURE_FLAGS_VALUES}
    loader={featureFlagLoader}
  >
    <Providers localizationLoader={localizationLoader}>{children}</Providers>
  </FeatureFlagsProvider>
);

RfisProvider.displayName = 'RfisProvider';

export default RfisProvider;
